import React from 'react'
import { Box, Typography, Tooltip, useTheme } from '@mui/material'
import { FIELD_ORDER } from '../Forms/types'
import { Task } from '../../types'
interface DigitalTaskProps {
  task: Task
}
const prettifyKey = (key: string) => {
  const parts = key.match(/[A-Z][a-z]+|[a-z]+/g)
  return parts?.slice(1).join(' ') || key
}

const DigitalTaskDetails: React.FC<DigitalTaskProps> = ({ task }) => {
  const theme = useTheme()
  const GROUPS = ['search', 'social', 'display', 'video', 'integration', 'seo']

  return (
    <Box
      sx={{
        flex: 1,
        overflowY: 'auto',
        p: 1,
        borderRight: { md: `1px solid ${theme.palette.divider}` },
      }}
    >
      {GROUPS.map(group => {
        const existingKeys = FIELD_ORDER[group].filter(key => task?.[key] !== undefined && task?.[key] !== null)
        if (existingKeys.length === 0) return null

        return (
          <Box
            key={group}
            mb={3}
            sx={{
              width: '100%',
              position: 'relative',
              borderBottom: `1px solid ${theme.palette.text.primary}`,
            }}
          >
            <Box
              sx={{
                position: 'sticky',
                top: 0,
                zIndex: 1,
                backgroundColor: theme.palette.background.section,
                py: 0.5,
              }}
            >
              <Typography
                sx={{
                  color: theme.palette.text.warning,
                  fontWeight: 'bold',
                  textAlign: 'left',
                  fontSize: 18,
                }}
              >
                {group.charAt(0).toUpperCase() + group.slice(1)}
              </Typography>
            </Box>
            {existingKeys.map(key => {
              const value = task[key]
              return (
                <Box
                  key={key}
                  mb={1}
                  display='flex'
                  alignItems={key === 'seoSpecifics' ? 'flex-start' : 'center'}
                  flexDirection={key === 'seoSpecifics' ? 'column' : 'row'}
                  sx={{
                    flexWrap: 'wrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    gap: 0.5,
                  }}
                >
                  <Typography
                    variant='body2'
                    fontWeight={600}
                    sx={{
                      fontSize: 16,
                      minWidth: 100,
                      maxWidth: 100,
                      color: theme.palette.text.secondary,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {['Platform', 'Options', 'Specifics'].some(substr => key.includes(substr))
                      ? prettifyKey(key)
                      : `Options`}
                  </Typography>
                  {Array.isArray(value) ? (
                    value.map((item, idx) => (
                      <Tooltip key={idx} title={item}>
                        <Typography
                          key={idx}
                          sx={{
                            ml: 1,
                            border: `1px solid ${theme.palette.text.primary}`,
                            borderRadius: 25,
                            minWidth: 115,
                            maxWidth: 115,
                            p: 0.5,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {item}
                        </Typography>
                      </Tooltip>
                    ))
                  ) : (
                    <Typography variant='body2' sx={{ ml: 1 }}>
                      {value}
                    </Typography>
                  )}
                </Box>
              )
            })}
          </Box>
        )
      })}
    </Box>
  )
}

export default DigitalTaskDetails
